<template>
<div>
<template v-for="tab in tabs">
        <div v-if="milestonesForTab(tab.key).length" class="heading" :key="tab.key">{{tab.title}}</div>
        <template v-for="element in milestonesForTab(tab.key)">
            <!-- <div v-if="element.type == 'Section'" :key="element.key">
                <span class="subheading" style="padding-left:43px">{{element.title}}</span>
            </div> -->
            <div v-if="element.type != 'Section' && element.type != 'Tab'" class="hoverable pa-1"  style="display:flex;border-radius:5px" :key="element.key"
            @click="$emit('jump', element)">
                <div style="padding-top:5px"><v-icon :color="(element.value || element.complete ? 'green' : 'grey lighten-2')" large>check_circle</v-icon></div>
                <div style="flex-grow:1;padding-top:10px;padding-left:10px" class="grey--text text--darken-1">
                    {{element.title}}<div v-if="element.value || element.complete" style="padding-top:0;padding-left:0" class="small-text">{{element.stamp | stamp}}</div>
                </div>
                <div @click.stop>
                    <v-menu left offset-y>
                        <template v-slot:activator="{ on }">
                        <v-btn color="grey" v-on="on" text icon>
                            <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="complete(element)">
                                <v-list-item-title>Complete</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="notApplicable(element)">
                                <v-list-item-title>Not Applicable</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="$emit('jump', element)">
                                <v-list-item-title>Go Here</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </template>

</template>
</div>
</template>

<script>
import OrderHelpers from '../helpers/OrderHelpers'

export default {
    data() {
        return {

        }
    },

    props: {

    },

    computed: {
        elements() {
            return this.$store.getters.elements
        },

        tabs() {
            return this.elements.filter(o => o.type && o.type == 'Tab').sort(OrderHelpers.sortAscending)
        },

        milestones() {
            return this.elements.filter(o => o.milestone && !o.na).sort(OrderHelpers.sortAscending)
        }
    },

    methods: {
        milestonesForTab(tabKey) {
            return this.milestones.filter(o => o.tabKey == tabKey)
        },

        complete(element) {
            element.value = true
            this.$emit('save', element)
        },

        notApplicable(element) {
            element.na = true
            this.$emit('save', element)
        }


    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// TransactionSummary.vue?488bd02a